import React, { useState } from 'react';
import { Map as MapIcon, Layers, User } from 'lucide-react';

/**
 * Google Maps embed — NO API KEY REQUIRED.
 * Uses google.com/maps embed with query.
 * Modes: satellite, roadmap, streetview
 */
export default function MapView({ query, height = 320 }) {
  const [mode, setMode] = useState('satellite');
  if (!query) return null;

  const q = encodeURIComponent(query + ' Dubai');
  const src =
    mode === 'satellite' ? `https://maps.google.com/maps?q=${q}&t=k&z=17&output=embed` :
    mode === 'streetview' ? `https://maps.google.com/maps?q=${q}&layer=c&cbll=&cbp=&output=svembed` :
    `https://maps.google.com/maps?q=${q}&z=15&output=embed`;

  return (
    <div className="glass overflow-hidden" data-testid="map-view">
      <div className="p-3 flex items-center justify-between border-b border-white/60">
        <div className="overline flex items-center gap-2"><MapIcon size={12}/> Location context</div>
        <div className="flex gap-1 bg-white/60 rounded-full p-0.5">
          {[
            { key: 'satellite', label: 'Satellite', icon: Layers },
            { key: 'roadmap', label: 'Map', icon: MapIcon },
            { key: 'streetview', label: 'Street', icon: User },
          ].map(({ key, label, icon: Ic }) => (
            <button key={key} onClick={() => setMode(key)} data-testid={`map-mode-${key}`}
                    className={`px-3 py-1 rounded-full text-xs flex items-center gap-1 ${mode === key ? 'bg-[#1A2530] text-white' : 'text-slate-600'}`}>
              <Ic size={11}/> {label}
            </button>
          ))}
        </div>
      </div>
      <iframe
        title={`map-${query}`} src={src} width="100%" height={height} style={{ border: 0 }}
        loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen
      />
      <div className="p-2 text-center">
        <a href={`https://www.google.com/maps/search/?api=1&query=${q}`} target="_blank" rel="noreferrer"
           className="text-xs text-[#679286] hover:underline">Open in Google Maps →</a>
      </div>
    </div>
  );
}
